/** Fire a custom event if tags are loaded (they only load with consent, never on booking pages). */
export function trackEvent(name, params = {}) {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
}
